export const SET_LAWS_DOCTYPES_FETCHING = 'SET_LAWS_DOCTYPES_FETCHING';
export const SET_LAWS_DOCTYPES_FETCHING_ERROR = 'SET_LAWS_DOCTYPES_FETCHING_ERROR'
export const SET_LAWS_DOCTYPES = 'SET_LAWS_DOCTYPES';
export const CLEAN_LAWS_DOCTYPES= 'CLEAN_LAWS_DOCTYPES';
export const ABORT_DOCTYPES_REQUEST = 'ABORT_DOCTYPES_REQUEST';



// WEBPACK FOOTER //
// ./src/redux_related/lawsDoctypes/actions.js